import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/sub/Scroll';
import React from 'react';
import logo from './assets/logo.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// const Home = lazy(() => import('./components/Home'));
const Contact = lazy( () => import( './components/Contact' ) );
const Plan = lazy(() => import('./components/Plan'));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="w-[100vw] h-[100vh] flex justify-center items-center bg-[rgb(18,18,18,0.7)]">
              <LazyLoadImage
                src={logo}
                alt=""
                className="w-20 h-20 loader"
              />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<App />}>
              <Route index element={<Plan />} />
              <Route
                path="contact-us"
                element={<Contact />}
              />
              {/* <Route
                path="plan"
                element={<Plan />}
              /> */}
            </Route>
          </Routes>
        </Suspense>
      </ScrollToTop>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
